import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { getInlineLoader } from "../Helpers";
import { FaInstagram, FaFacebook, FaLinkedin, FaYoutube, FaTiktok } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function Footer(props) {

	const appContext = useContext(AppContext);

	const [ ready, setReady ] = useState(false);

	async function init() {
		setReady(false);
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px",
					borderTop: "1px solid var(--primaryColor)"
				}}
			>
				<div className="container">
					<div className="row">
						
						{/* USEFUL LINKS */}
						<div className="col-md-4">
							<h6 className="main-section-title font-bold">
								Useful Links
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "" })}>
								Home
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "about_us" })}>
								About Us
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "services" })}>
								Services
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "news" })}>
								News
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "gallery" })}>
								Gallery
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "contact_us" })}>
								Contact Us
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px", cursor: "pointer" }}
								onClick={() => appContext.navTo({ item: "donate" })}>
								Donate
							</h6>
						</div>

						{/* ADDRESS */}
						<div className="col-md-4">
							<h6 className="main-section-title font-bold">
								Address
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px" }}>
								P.O. Box 1212, Kigoma <br/>
								Kigoma Region, Tanzania
							</h6>
						</div>

						{/* CONTACT */}
						<div className="col-md-4">
							<h6 className="main-section-title font-bold">
								Reach Out
							</h6>

							<h6 className="font-bold text-light" style={{ fontSize: "14px", padding: "10px" }}>
								Email: <span>info@tyidi.or.tz</span> <br/>
								Phone: <span>+255 756 528 022</span>
							</h6>
						</div>

						{/* SOCIAL MEDIA */}
						<div className="col-md-12 mt-4">
							<div className="row text-center">

								<div className="col-4 col-md-2 mb-3">
									<FaInstagram size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.instagram.com/tyidi2026", "_blank")} />
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaFacebook size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.facebook.com/@TyidiTanzania", "_blank")} />
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaLinkedin size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.linkedin.com/in/tyidi-tanzania-9434793a5", "_blank")} />
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaYoutube size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.youtube.com/@tanzaniayouthIntergrateddevelo", "_blank")} />
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaTiktok size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://www.tiktok.com/@tyidi2025", "_blank")} />
								</div>

								<div className="col-4 col-md-2 mb-3">
									<FaXTwitter size={28} style={{ cursor: "pointer" }}
										onClick={() => window.open("https://x.com/Tyidi2026", "_blank")} />
								</div>

							</div>
						</div>

						{/* COPYRIGHT */}
						<div className="col-md-12 text-center font-bold">
							<hr/>

							<h6 className="text-light" style={{ fontSize: "14px", paddingTop: "20px" }}>
								&copy; TYIDI - {getCurrentYear()}
							</h6>

							<h6 className="text-light" style={{ fontSize: "14px" }}>
								Powered By TYIDI Organization
							</h6>

							<h6 className="text-light" style={{ fontSize: "14px", paddingTop: "20px" }}>
								Website Developed By <a target="_blank" href="https://werenium.com">Werenium Technologies</a>
							</h6>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
